import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDown, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function FAQ() {
  const { t } = useTranslation();
  const questions = Array.from({ length: 10 }, (_, i) => i + 1);
  return (
    <div className="min-h-screen bg-white text-[#0B1B2B]">
      <Header />
      <section className="bg-[#F7F8FA] pt-20 md:pt-28 pb-16">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <div className="text-xs uppercase tracking-[0.25em] text-[#1F3A60] font-medium mb-4">{t("ds.page_faq.kicker")}</div>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#0B1B2B] mb-5">{t("ds.page_faq.title")}</h1>
          <p className="text-[#52606E] text-lg">{t("ds.page_faq.intro")}</p>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10 space-y-3">
          {questions.map((idx) => <FaqItem key={idx} idx={idx} t={t} />)}
        </div>
      </section>
      <section className="py-20 bg-gradient-to-br from-[#0B1B2B] to-[#1F3A60] text-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl mb-4">{t("ds.footer_cta.title")}</h2>
          <Link to="/#zonnecheck" className="inline-flex items-center gap-2 bg-[#F5C24C] hover:bg-[#E5AE2F] text-[#0B1B2B] font-medium rounded-full px-8 py-4 mt-2">
            {t("ds.footer_cta.btn")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}

function FaqItem({ idx, t }) {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid={`faq-full-${idx}`} className={`border rounded-2xl transition-all ${open ? "border-[#F5C24C] bg-[#FFF9EB]" : "border-[#E5E9EE] bg-white"}`}>
      <button onClick={() => setOpen(!open)} className="w-full flex justify-between items-center text-left px-6 py-5">
        <span className="font-medium pr-4">{t(`ds.page_faq.q${idx}`)}</span>
        <ChevronDown className={`w-5 h-5 text-[#52606E] shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-6 pb-5 text-[#52606E] leading-relaxed whitespace-pre-line">{t(`ds.page_faq.a${idx}`)}</div>}
    </div>
  );
}
